<template>
  <div class="log">
    <h2 class="title">
      操作履歴
    </h2>
    <div class="function-menu">
      <div
        class="function-ym-select"
        @click="isOpenYmSelect = !isOpenYmSelect"
        v-on-clickaway="ymSelectHidden"
      >
        <span class="function-ym-select-text">{{ getReplacedYm(currentYm) }}</span>
        <transition>
          <ul class="drop-down-list drop-down-list-scrollable ym-list" v-show="isOpenYmSelect">
            <li v-for="(ym, index) in ymList" :key="index" @click="selectYm(ym)">{{ getReplacedYm(ym) }}</li>
          </ul>
        </transition>
      </div>
      <div
        class="function-day-select"
        @click="isOpenDaySelect = !isOpenDaySelect"
        v-on-clickaway="daySelectHidden"
      >
        <span class="function-day-select-text">{{ getReplacedDay(currentDay) || '----' }}</span>
        <transition>
          <ul class="drop-down-list drop-down-list-scrollable day-list" v-show="dayList.length > 0 && isOpenDaySelect">
            <li v-for="(day, index) in dayList" :key="index" @click="selectDay(day)">{{ getReplacedDay(day) }}</li>
          </ul>
        </transition>
      </div>
      <div class="function-download">
        <button :disabled="!isFirstView && dayList.length === 0" @click="getCSV">ダウンロード</button>
        <a id="csv-download-link"></a>
      </div>
    </div>
    <div class="pagination-wrapper">
      <Pagination
        :currentPageIndex="pager.current"
        :maxPageIndex="pager.last"
        @updateCurrentPageIndex="updateCurrentPageIndex"
      />
    </div>
    <div class="content-table-wrapper">
      <table class="content-table">
        <thead>
          <tr class="kind">
            <td v-for="title in tableTitles" :key="title.name">
              {{ title.visibleName }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr class="value" v-for="item in logContent" :key="item.date">
            <td v-for="title in tableTitles" :key="title.name">
              {{ item[title.name] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-wrapper">
      <Pagination
        :currentPageIndex="pager.current"
        :maxPageIndex="pager.last"
        @updateCurrentPageIndex="updateCurrentPageIndex"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Util/Pagination'
import { mixin as onClickAway } from 'vue-clickaway'

export default {
  components: {
    Pagination,
  },
  mixins: [onClickAway],
  async created () {
    const now = new Date()
    this.currentYm = now.getFullYear() + '-' + this.zeroPad(now.getMonth() + 1)
    this.currentDay = this.zeroPad(now.getDate())
    await this.getContents()
    this.isFirstView = false
  },
  data () {
    return {
      pager: {
        last: 1,
        current: 1,
      },
      isFirstView: true,
      currentYm: null,
      currentDay: null,
      isOpenYmSelect: false,
      isOpenDaySelect: false,
      ymList: [],
      dayList: [],
      tableTitles: [
        {
          name: 'dateTime',
          visibleName: '操作日時'
        },
        {
          name: 'ipAddress',
          visibleName: 'IPアドレス'
        },
        {
          name: 'userAgent',
          visibleName: 'ユーザーエージェント'
        },
        {
          name: 'loginId',
          visibleName: 'ログインID'
        },
        {
          name: 'message',
          visibleName: 'ログメッセージ'
        },
      ],
      logContent: [],
    }
  },
  computed: {
    getCurrentDate () {
      if (!this.currentYm || !this.currentDay) return null
      return `${this.currentYm}-${this.currentDay}`
    }
  },
  methods: {
    // ページ数を更新する
    updateCurrentPageIndex (index) {
      if (index > this.pager.last || index < 1) return
      this.pager.current = index
      this.getContents()
    },
    // APIからデータを取得する
    async getContents () {
      const urlSP = new URLSearchParams()
      urlSP.append('page', this.pager.current)
      urlSP.append('ym', this.currentYm)
      urlSP.append('day', this.currentDay)
      this.isFirstView && urlSP.append('isFirstView', 1)

      const json = await this.$http({
        url: `/log/?${urlSP.toString()}`,
        type: 'GET',
      })
      if (json && json.status === 200 && json.data) {
        this.logContent = json.data.logs.logContent
        this.pager.current = json.data.logs.currentPage
        this.pager.last = json.data.logs.maxPage
        if (this.isFirstView) this.ymList = json.data.ymList
        this.dayList = json.data.dayList
        this.currentDay = json.data.day ? this.zeroPad(json.data.day) : null
      }
      return json
    },
    getCSV () {
      const urlSP = new URLSearchParams()
      urlSP.append('ym', this.currentYm)
      urlSP.append('day', this.currentDay)
      this.$http({
        url: `/log/download?${urlSP.toString()}`,
        type: 'GET',
        output: 'blob',
      }).then(resp => {
        if (resp.blob) {
          const el = document.getElementById('csv-download-link')
          // blobとファイル名をaタグに差し込んでクリック(=download)
          const url = window.URL.createObjectURL(resp.blob)
          el.href = url
          el.setAttribute('download', resp.fileName)
          el.click()
          el.href = ''
          el.removeAttribute('download')
          // 作ったURLマッピングは即時破棄(=blobメモリ解放)
          window.URL.revokeObjectURL(url)
        }
      })
    },
    getReplacedYm (ym) {
      if (!ym) return null
      return ym.replace(/(\d{4})-(\d{2})/, '$1年$2月')
    },
    getReplacedDay (day) {
      if (!day) return null
      return this.zeroPad(day) + '日'
    },
    // 日付選択パネルを閉じる
    ymSelectHidden () {
      this.isOpenYmSelect = false
    },
    daySelectHidden () {
      this.isOpenDaySelect = false
    },
    // 日付選択パネルで日付を選択したときのメソッド
    async selectYm (ym) {
      this.currentYm = ym
      this.pager.current = 1 // 選択ページを1に戻す
      await this.getContents()
    },
    async selectDay (day) {
      this.currentDay = this.zeroPad(day)
      this.pager.current = 1 // 選択ページを1に戻す
      await this.getContents()
    },
    zeroPad (num) {
      // ゼロパディングで2桁する。ex) 1 → 01、12 → 12
      return ('0' + num).slice(-2)
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  padding-left: 20px;
  margin-bottom: 20px;
  font-size: 24px;
  color: rgba($baseFontColor, 0.9);
}

.function-menu {
  display: flex;
  margin-bottom: 15px;
  .function-ym-select {
    position: relative;
    .function-ym-select-text {
      cursor: pointer;
      height: 30px;
      width: 85px;
      line-height: 30px;
      padding: 0 13px 0 10px;
      text-align: left;
      font-size: 12px;
      border-radius: 5px;
      display: block;
      background-color: #fff;
      border: 1px solid #c6c6c6;
    }
    &:after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f107";
      position: absolute;
      top: 6px;
      left: 90px;
      font-size: 15px;
    }
  }
  .function-day-select {
    position: relative;
    margin-right: 15px;
    .function-day-select-text {
      cursor: pointer;
      height: 30px;
      width: 50px;
      line-height: 30px;
      padding: 0 8px 0 10px;
      text-align: left;
      font-size: 12px;
      border-radius: 5px;
      display: block;
      background-color: #fff;
      border: 1px solid #c6c6c6;
    }
    &:after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f107";
      position: absolute;
      top: 6px;
      left: 50px;
      font-size: 15px;
    }
  }
  .function-download {
    button {
      color: #fff;
      border: none;
      height: 30px;
      line-height: 30px;
      padding: 0;
      background: $primaryColor;
      white-space: nowrap;
      text-align: center;
      font-size: 12px;
      border-radius: 5px;
      cursor: pointer;
      user-select: none;
      padding: 0 15px;
      &::before {
        padding-right: 8px;
        font-size: 14px;
        content: '\f56d';
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
      &:hover {
        background: $primaryHoverColor;
      }
      &:active {
        background: $primaryActiveColor;
      }
      &:focus {
        outline:0;
      }
      &:disabled {
        background: #6c757d;
        opacity: 0.8;
        cursor: default;
      }
    }
  }
}

.ym-list {
  width: 88px;
}
.day-list {
  width: 45px;
}
.drop-down-list {
  padding: 10px 11px;
  font-size: 12px;
  li {
    cursor: pointer;
  }
}

.content-table {
  border-collapse: collapse;
  font-size: 14px;
  word-break: break-all;
  tr {
    &:nth-child(even) {
      background-color: #eaeaea;
    }
    &:nth-child(odd) {
      background-color: #fff;
    }
  }
  td,th {
    border: 1px solid #ddd;
  }
  tr.kind {
    background-color: #eaeaea;
    font-weight: 700;
    > td {
      padding: 10px 5px;
    }
  }
  .value {
    > td {
      padding: 5px;
    }
  }
}

tr {
  td {
    &:nth-of-type(1) {
      width: 15%;
    }
    &:nth-of-type(2) {
      width: 10%;
    }
    &:nth-of-type(3) {
      width: 25%;
    }
    &:nth-of-type(4) {
      width: 10%;
    }
    &:nth-of-type(5) {
      width: 40%;
    }
  }
}

.pagination-wrapper {
  padding-top: 25px;
}
</style>
